document.addEventListener('DOMContentLoaded', function() {
  
  // Function to handle image fade-in
  function handleImageLoad(img) {
    if (img.complete) {
      img.classList.add('loaded');
    } else {
      img.addEventListener('load', function() {
        this.classList.add('loaded');
      });
    }
  }
  
  // Handle initial images
  const initialImages = document.querySelectorAll('.product-card__image, .product-media__image');
  initialImages.forEach(handleImageLoad);
  
  // Watch for dynamically added images (thumbnails loaded later)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Check if the node itself is an image
          if (node.matches && node.matches('.product-card__image, .product-media__image')) {
            handleImageLoad(node);
          }
          // Check for images within the added node
          const images = node.querySelectorAll && node.querySelectorAll('.product-card__image, .product-media__image');
          if (images) {
            images.forEach(handleImageLoad);
          }
        }
      });
    });
  });
  
  // Start observing the document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
